import LabelController from './label.controller';
import { LabelProps } from './label.model';

const Label = (props: LabelProps) => {
  return <LabelController {...props} />;
};

export default Label;
